import {inject} from "aurelia-framework";
import {OperationInterface} from "./operation.interface";
import {DialogService} from "aurelia-dialog";
import {BulkOperationQueryCore} from "./utility/bulk-operation-query-core";
import {I18N} from "aurelia-i18n";
import {UserClient} from "../../api/user-client";
import {UpdateContingentCalendarView} from "./utility/update-contingent-calendar-view";

@inject(
    UserClient,
    DialogService,
    BulkOperationQueryCore,
    I18N,
)
export class UpdateContingentCalendar extends OperationInterface {
    constructor(
        userClient,
        dialogService,
        bulkOperationQueryCore,
        i18n,
    ) {
        super();

        this.userClient = userClient;
        this.dialogService = dialogService;
        this.bulkOperationQueryCore = bulkOperationQueryCore;
        this.i18n = i18n;
    }

    getName() {
        return 'update-contingent-calendar';
    }

    execute(context) {
        return this.dialogService.open({
            viewModel: UpdateContingentCalendarView,
            model: {
                title: 'price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.label',
                onSave: this.#onSaveCallback(context).bind(this),
            }
        }).whenClosed();
    }

    getActions(items, operationConfig) {
        return [
            {
                type: 'bulk-operation',
                operationConfig: operationConfig,
                label: this.i18n.tr('price.models.contingent-calendar.display.bulkOperations.update-contingent-calendar.label'),
            }
        ];
    }

    #onSaveCallback(context) {
        return (payload) => {
            return this.bulkOperationQueryCore.query(
                context.operationConfig.type,
                {
                    items: context.items,
                    ...payload,
                }
            )
        };
    }
}
